import React from 'react'
import Seminar from "../images/seminarroom1.jpeg";
import Seminarroom from "../images/seminarroom.jpeg";
import Room from "../images/meetingroom.jpeg";
import Room2 from "../images/meetinghall.jpeg";
import Room3 from "../images/room2.jpeg";

function Slider2() {
  return (
    <div>
<div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src={Seminar} class="d-block w-100" alt="berhampore lodge"/>
    </div>
    <div class="carousel-item">
      <img src={Seminarroom} class="d-block w-100" alt="Berhampore Lodge"/>
    </div>
    <div class="carousel-item">
      <img src={Room} class="d-block w-100" alt="Best Hotel in Berhampore"/>
    </div>
    <div class="carousel-item">
      <img src={Room2} class="d-block w-100" alt="Berhampore Lodge"/>
    </div>
    <div class="carousel-item">
      <img src={Room3} class="d-block w-100" alt="Berhampore Lodge"/>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
</div>
  )
}

export default Slider2
